export function PrintInNewTab (htmlContent) {
    const printWindow = window.open('', '_blank');

    // Build complete HTML document
    printWindow.document.write(htmlContent);

    printWindow.document.close();
}
